module.exports = __webpack_public_path__ + "img/goods_list.137910cf.png";